export default __webpack_public_path__ + "media/images/features/toyono/illust_right-be3c325887ca52eaa5cfbae66e7b3677.png";